import store from '@/store';
import { modulesName } from '@/modules';
import { ACTION_TYPES } from '../store/types';

const environment = {
  Training: "Training"
}

//Common Mixins
export const commonMixin = {
  methods: {
    //Return the Message of Key requested
    getMessage(key) {
      return store.getters[`${modulesName.commonModuleName}/resource`](key);
    },
    //Load all resources requesteds
    loadMessages(keys) {
      if (keys != undefined)
        store.dispatch(
          `${modulesName.commonModuleName}/${ACTION_TYPES.GET_RESOURCES}`,
          keys
        );
    },
    currentAcademicYear() {
      return store.getters[
        `${modulesName.commonModuleName}/currentAcademicYear`
      ];
    },
    isTrainingEnv(){      
      return process.env.VUE_APP_ENVIRONMENT == environment.Training;      
    }
  },
};
